<template>
  <div class="homePage">
    <div class="banner"><img :src="banner" /></div>
    <div class="tool-box">
      <div class="title">三才|Tri-leverl ，专业的商用清洁工具</div>
      <div class="tool-img">
        <img v-for="(item, index) in toolList" :key="index" :src="item" />
      </div>
    </div>
    <div class="plan-box" id="solution"><img :src="plan" /></div>
    <div class="reason-box">
      <div class="title">为什么选择三才|Tri-leverl </div>
      <div class="subtitle">具有可靠的质量、人性化的设计、环保的材料和优质的售后服务 </div>
      <img :src="reason" />
    </div>
    <div class="contactUs-box"><img :src="contactUs" /></div>
  </div>
</template>
<script>

export default {
  name: 'homePage',
  data() {
    return {
      banner: require("../../assets/img/banner.png"),
      contactUs: require("../../assets/img/contactUs.png"),
      plan: require("../../assets/img/plan.png"),
      reason: require("../../assets/img/reason.png"),
      toolList: [require("../../assets/img/tool1.png"), require("../../assets/img/tool2.png"), require("../../assets/img/tool3.png"), require("../../assets/img/tool4.png"), require("../../assets/img/tool5.png"), require("../../assets/img/tool6.png")]
    }
  }
}
</script>
<style lang="less" scoped>
.homePage {
  background: #fff;

  img {
    display: block;
  }

  .banner {
    width: 100%;
    // height: 550px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .title {
    font-weight: bold;
    font-size: 30px;
    color: #000000;
    margin-bottom: 53px;
    text-align: center;
  }

  .subtitle {
    font-weight: 400;
    font-size: 16px;
    color: #999999;
    text-align: center;
  }

  .tool-box {
    background: linear-gradient(180deg, #F0F4FF 0%, #FFFFFF 100%);
    padding: 88px 260px;

    .tool-img {
      display: flex;
      flex-wrap: wrap;

      img {
        width: 30%;
        flex-grow: 1;
        margin: 10px 10px;
        cursor: pointer;
      }
    }

  }

  .plan-box {
    width: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .reason-box {
    width: 100%;
    background: #fff;
    padding: 106px 106px 210px;
    box-sizing: border-box;

    .title {
      margin-bottom: 8px;
    }

    img {
      margin-top: 40px;
      width: 100%;
      height: 100%;
    }
  }

  .contactUs-box {
    width: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
